import baseApi from '../common/apis/base-api';

const SIGNATURES_API_ENDPOINT = 'Signature';

export const postGosForm = (formData: FormData) => {
  return baseApi.post(`${SIGNATURES_API_ENDPOINT}`, formData);
};
